import { useContext } from "react";
import { AdMaterialAnnotationsContext } from "pages/MaterialSpecs/components";

export const useAnnotationsHandler = () => useContext(AdMaterialAnnotationsContext);
